<template>
  <div class="p-news">
    <section class="c-p-r about-banner">
      <div class="c-d-f c-fd-c c-ai-c c-c-white c-ta-c cm-width about-banner-desc">
        <p class="c-fs-38 c-mb-32 c-fw-b top-title">{{title}}</p>
        <p class="c-fs-16 c-ff-l top-desc">{{desc}}</p>
      </div>
    </section>
    <section class="about-menu">
      <div class="c-m-a c-d-f c-jc-sb c-ai-c menu-wrap">
        <div class="c-fw-b hover" :class="currentTab === 1 ? 'bd-color' : ''" @click="clickTab(1)">企业新闻</div>
        <div class="c-fw-b hover" :class="currentTab === 2 ? 'bd-color' : ''" @click="clickTab(2)">行业新闻</div>
      </div>
    </section>
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="cm-width c-pb-164 news-wrap">
        <section class="news-left">
          <section class="c-cs-p c-mb-16 news-item" v-for="(item, index) in newsList" :key="index" @click="toUrl(item.url)">
            <div class="news-img">
              <img :src="item.img">
            </div>
            <div class="news-text">
              <div class="c-fs-16 c-fw-b c-ellipsis-1">{{item.title}}</div>
              <p class="c-fs-12 c-mt-8 c-c-text-grey">{{item.date}}</p>
              <div class="c-fs-12 c-c-text-black c-lh-22 c-mt-12 c-ta-j c-ellipsis-4">{{item.desc}}</div>
            </div>
          </section>
        </section>
        <section class="news-right">
          <p class="c-fs-16 c-mb-16 c-fw-b">精选内容</p>
          <div>
            <p v-for="(item, index) in recommendList" :key="index" class="c-fs-12 c-cs-p c-mb-8 c-c-text-black c-ellipsis-1 news-link" @click="toUrl(item.url)">{{index + 1}}、{{item.title}}</p>
          </div>
          <div class="c-mt-48 c-mb-24 c-fs-12 c-c-text-black">
            <p class="c-fs-16 c-c-text-color c-mb-16 c-fw-b">联系我们</p>
            <p class="c-mb-8">安徽高颐科技有限公司</p>
            <p class="c-mb-8">地址：安徽省池州经济技术开发区电子信息产业园7楼</p>
            <p class="c-mb-8">电话：4006-111-696</p>
            <p>邮箱：joshua#quaee.com</p>
          </div>
          <img src="../assets/header/QR-code1.png" class="code">
        </section>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="cm-width c-pb-24 news-wrap-mobile">
        <section class="news-left">
          <section class="c-cs-p c-mb-16 news-item" v-for="(item, index) in newsList" :key="index" @click="toUrl(item.url)">
            <div class="news-img">
              <img :src="item.img">
            </div>
            <div class="news-text">
              <div class="c-fs-14 c-fw-b c-ellipsis-1">{{item.title}}</div>
              <p class="c-fs-12 c-mt-4 c-c-text-grey">{{item.date}}</p>
              <div class="c-fs-12 c-c-text-black c-lh-18 c-mt-4 c-ta-j c-ellipsis">{{item.desc}}</div>
            </div>
          </section>
        </section>
      </section>
    </section>
  </div>
</template>

<script>
const companyNewsList = [{
  title: '第五届Zabbix峰会 中国深圳',
  desc: 'QUAEE高颐和Zabbix在中国深圳举办的第五届Zabbix峰会上会面，高颐科技技术总监在会上将高颐科技的猫维智能运维平台服务于行业大客户的智能运维上的技术分享给前来参会的厂商和Zabbix爱好者们。',
  date: '2020-09-25',
  img: require('../assets/news/article4-1.jpg'),
  url: '/article4'
}, {
  title: 'QUAEE高颐和Zabbix达成战略合作 成为Zabbix中国区重要合作伙伴',
  desc: '猫维与zabbix原厂签署合作伙伴协议，成为其中国区重要的合作伙伴之一，为中国更多客户提供更有高度、更智能、更全面的服务和支持。',
  date: '2020-04-10',
  img: require('../assets/news/pic2.jpg'),
  url: '/article1'
}]

const industryNewsList = [{
  title: 'Grafana如何助力Zabbix，打造漂亮的监控界面？',
  desc: 'Grafana是一个跨平台的开源的度量分析和可视化工具，有着非常漂亮的图表和布局展示，功能齐全的度量仪表盘和图形编辑器，官方原生支持Zabbix数据输出，而Grafana与Zabbix对接能够帮助大家实现对系统的实时监控以及可视化展示。',
  date: '2020-07-24',
  img: require('../assets/news/pic3.jpg'),
  url: '/article2'
}, {
  title: '第五届Zabbix峰会中国站',
  desc: '9月25-26日加入Zabbix中国峰会，学习前沿的监控技术，聆听多元的行业案例，分享技术最佳实践，参加Zabbix实践操作工作坊，还有产品Demo展台、合作伙伴展台、特邀展台展示等您来参观！',
  date: '2020-09-25',
  img: require('../assets/news/pic4.png'),
  url: '/article3'
}]

const recommendList = [{
  title: '第五届Zabbix峰会 中国深圳',
  url: '/article4'
}, {
  title: 'QUAEE高颐和Zabbix达成战略合作 成为Zabbix中国区重要合作伙伴',
  url: '/article1'
}, {
  title: 'Grafana如何助力Zabbix，打造漂亮的监控界面？',
  url: '/article2'
}
// {
//   title: '第五届Zabbix峰会中国站',
//   url: '/article3'
// }
]

export default {
  name: 'news',
  data () {
    return {
      currentTab: 1,
      newsList: companyNewsList,
      recommendList: recommendList
    }
  },
  computed: {
    title () {
      return this.currentTab === 1 ? '企业新闻' : '行业新闻'
    },
    desc () {
      return this.currentTab === 1 ? '报道企业最新消息，实时发布企业动向' : '贴近市场，挖掘需求，引领行业'
    }
  },
  methods: {
    toUrl (url) {
      if (url) {
        this.$router.push(url)
      }
    },
    clickTab (index) {
      if (index === 1) {
        this.currentTab = 1
        this.newsList = companyNewsList
      } else {
        this.currentTab = 2
        this.newsList = industryNewsList
      }
    }
  }
}
</script>

<style lang="scss">
.p-news {
  min-height: calc(100vh - 44px - 161px);
  .about-banner {
    height: 560px;
    background: url("../assets/news/news-banner3.jpg") no-repeat;
    background-size: cover;
    background-position: top;
    @media screen and (max-width: $max-width-standard) {
      height: 232px;
      .top-title {
        font-size: 19px;
        margin-bottom: 12px;
      }
      .top-desc {
        width: 70%;
        font-size: 9px;
        line-height: 16px;
        margin-bottom: 15px!important;
      }
    }
    .about-banner-desc {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .about-menu {
    height: 64px;
    font-size: 20px;
    box-shadow: 0px 0px 34px 8px rgba(93, 102, 172, 0.2);
    .menu-wrap {
      width :30%;
      height: 100%;
      .hover {
        height: 100%;
        padding: 0px 12px;
        cursor: pointer;
        display: flex;
        align-items: center;
        border-bottom: 2px solid transparent;
        &.bd-color {
          border-bottom-color: $orange;
        }
        &:hover {
          border-bottom-color: $orange;
        }
      }
    }
    @media screen and (max-width: $max-width-standard) {
      height: 42px;
      font-size: 14px;
      .menu-wrap {
        width: 60%;
        padding: 0;
      }
    }
  }
  .news-wrap {
    display: flex;
    justify-content: space-between;
    margin-top: 80px;
    .news-left {
      width: 70%;
      .news-item {
        height: 200px;
        padding: 18px;
        display: flex;
        justify-content: space-between;
        background: transparent;
        @media screen and (max-width: $max-width-standard) {
          width: 100%;
        }
        &:hover {
          background: white;
          box-shadow: 0px 0px 34px 8px rgba(93, 102, 172, 0.2);
        }
        .news-img {
          width: 35%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .news-text {
          width: 60%;
        }
      }
    }
    .news-right {
      width: 26%;
      .news-link {
        &:hover {
          color: $text-blue;
        }
      }
      .code {
        width: 160px;
      }
    }
  }
  .news-wrap-mobile {
    margin-top: 40px;
    .news-left {
      .news-item {
        height: 100px;
        padding: 8px;
        display: flex;
        justify-content: space-between;
        background: transparent;
        border: 1px solid $border-color;
        .news-img {
          width: 35%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .news-text {
          width: 60%;
        }
      }
    }
  }
}
</style>
